// extracted by mini-css-extract-plugin
export default {"pageHeader":"_1wPMHbFf2dKeCdDasqtsZm"};